import { Inject, Injectable } from "@angular/core"
// Import the core angular services.
import { DOCUMENT } from "@angular/platform-browser"

@Injectable()
export class DomEventsService {
  private doc: Document

  constructor(@Inject(DOCUMENT) doc: any) {
    this.doc = doc
  }

  public triggerOnDocument(eventType: string): Event {
    return this.triggerOnElement(this.doc, eventType)
  }

  // I trigger the given event configuration on the given element.
  public triggerOnElement(
    nativeElement: any,
    eventType: string,
    bubbles: boolean = true,
    cancelable: boolean = false
  ): Event {
    const customEvent = this.createEvent(eventType, bubbles, cancelable)
    nativeElement.dispatchEvent(customEvent)
    return customEvent
  }

  private createEvent(eventType: string, bubbles: boolean, cancelable: boolean): Event {
    let customEvent: CustomEvent

    try {
      customEvent = new CustomEvent(eventType, {
        bubbles: bubbles,
        cancelable: cancelable
      })
    } catch (error) {
      // Fallback for IE
      customEvent = this.doc.createEvent("CustomEvent")
      customEvent.initCustomEvent(eventType, bubbles, cancelable, null)
    }
    return customEvent
  }
}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/dom-events.service.ts